/**
 * @generated SignedSource<<bfdce23e94149e36924c87fb992b7e44>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionDeleteButtonFragment$data = {
  readonly id: string;
  readonly version: Semver;
  readonly workspace: {
    readonly id: string;
    readonly slug: string;
  };
  readonly " $fragmentType": "WorkspaceVersionDeleteButtonFragment";
};
export type WorkspaceVersionDeleteButtonFragment$key = {
  readonly " $data"?: WorkspaceVersionDeleteButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionDeleteButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionDeleteButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};
})();

(node as any).hash = "2e8242e818f669eedff05b59f1a18d82";

export default node;
